// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"SampleTableActionRender_actionContainer_3tie1","buttonContainer":"SampleTableActionRender_buttonContainer_Ff7sF"};